export default {
	JoiningFee: '0',
	MembershipFee: '0',
	AddonFee: '0',
	SubsequentPayments: '0',
	TodaysPayment: '0'
};
